
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19599.75 -13607.061 17.941 14.121"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_183_148","data-name":"Symbol 183 – 148","transform":"translate(-20972.895 -14249)","opacity":".34"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"line","d":"M5.824 6.035L0 0","transform":"translate(1384.2 643)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"line-2","d":"M0 0h15.882","data-name":"line","transform":"translate(1373.895 649)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"line-3","d":"M5.824 0L0 5.965","data-name":"line","transform":"translate(1384.2 649.035)"}})])])
          )
        }
      }
    